
export default (base64, fileName, type = 'application/pdf') => {
  const a = document.createElement('a')

  a.style.display = 'none'
  a.href = `data:${type};base64,${base64}`
  document.body.appendChild(a)
  a.download = fileName

  a.click()
  a.remove()
}